import React from "react";
import { Link } from "@/components/common/Link";
export default function Footer() {
  const navigationLinks = [{
    label: "Home",
    href: "/TheCarefulConsultingPage"
  }, {
    label: "About Us",
    href: "#"
  }, {
    label: "Our Approach",
    href: "#"
  }, {
    label: "Contact",
    href: "#"
  }];
  const regionLinks = [{
    label: "North America",
    href: "#"
  }, {
    label: "Europe",
    href: "#"
  }, {
    label: "Asia Pacific",
    href: "#"
  }, {
    label: "Middle East & Africa",
    href: "#"
  }];
  const serviceLinks = [{
    label: "Global Expansion Strategy",
    href: "#"
  }, {
    label: "Corporate Strategy Development",
    href: "#"
  }, {
    label: "Growth Advisory",
    href: "#"
  }, {
    label: "Supply Chain Optimization",
    href: "#"
  }, {
    label: "Brand Matching",
    href: "#"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Terms of Service",
    href: "#"
  }, {
    label: "Cookie Policy",
    href: "#"
  }, {
    label: "Legal Notice",
    href: "#"
  }];
  return <footer id="footer" className="relative min-h-[300px] bg-background bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/tcc_subtle_paper_texture.png')] bg-repeat pt-24 pb-12 border-t border-border">
      <div className="container mx-auto px-6 max-w-7xl flex flex-col h-full">
        {}
        <div className="flex justify-center mb-20">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/tcc_primary_logo_embossed.png" alt="The Careful Consulting" className="h-24 w-auto object-contain" />
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-24 flex-grow">
          {}
          <div className="flex flex-col">
            <h3 className="text-foreground font-semibold tracking-widest uppercase text-xs mb-6">
              Navigation
            </h3>
            <ul className="flex flex-col gap-4">
              {navigationLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-secondary-foreground hover:text-primary transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="text-foreground font-semibold tracking-widest uppercase text-xs mb-6">
              Global Regions
            </h3>
            <ul className="flex flex-col gap-4">
              {regionLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-secondary-foreground hover:text-primary transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="text-foreground font-semibold tracking-widest uppercase text-xs mb-6">
              Expertise
            </h3>
            <ul className="flex flex-col gap-4">
              {serviceLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-secondary-foreground hover:text-primary transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="text-foreground font-semibold tracking-widest uppercase text-xs mb-6">
              Legal
            </h3>
            <ul className="flex flex-col gap-4">
              {legalLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-secondary-foreground hover:text-primary transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="flex flex-col md:flex-row justify-between items-end mt-auto pt-8 border-t border-border/40">
          <p className="text-secondary-foreground tracking-[0.15em] text-xs uppercase mb-6 md:mb-0">
            &copy; {new Date().getFullYear()} The Careful Consulting. All rights reserved.
          </p>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/tcc_decorative_star_embossed.png" alt="" className="h-8 w-8 object-contain opacity-90" aria-hidden="true" />
        </div>
      </div>
    </footer>;
}